export default {
  id: 'xhelos',
  name: 'Xhelos',
  theme: 'sci-fi',
  versionPrefix: '2',
  description: 'Strategic space combat',
  pageTitle: 'Xhelos - Strategic Space Combat',
  colors: {
    primary: '#00ff9d',
    secondary: '#ff006e',
    background: '#0a0e27',
    text: '#ffffff',
  },
  fonts: {
    heading: '"Exo 2", sans-serif',
    body: '"Roboto", sans-serif',
  },
  logo: '/images/brands/xhelos-logo.png',
  map: {
    tileSize: 42,           // Desktop (1024-1535px)
    tileSizeTablet: 36,     // Tablet (768-1023px)
    tileSizeMobile: 32,     // Mobile (480-767px)
    tileSizePortrait: 28,   // Portrait (< 480px)
    tileSizeWide: 48,       // Wide (≥ 1536px)
  },
  loading: {
    barColor: '#00ff9d',      // Cyan (primary)
    barGlow: '#00ff9d80',     // Cyan with transparency
    backgroundColor: '#0a0e27', // Dark background
    textColor: '#ffffff',      // White text
  },
};
